import { toObject, toUrlParams } from '@anm/helpers/parseParams';
import compose from 'lodash/fp/compose';

import pickUTMParams from '../pickUTMParams';

const getUTMQuery = (query = location.search) =>
  compose(toUrlParams, pickUTMParams, toObject)(query);

export default getUTMQuery;
